<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 验证码 -->
      <section slot="verifyCodeOrigin" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.verifyCodeOrigin" placeholder="请输入">
          <article
            class="getCodeBtn"
            :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
            slot="suffix"
            @click="getSms"
          >
            {{smsTime || '获取短信验证码'}}
          </article>
        </el-input>
      </section>
      <!-- 验证码 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  sendSmsCode,
} from 'api/user';
import {
  mapState,
} from 'vuex';
export default {
  data () {
    return {
      smsTimer: null,
      smsTime: 0,
      baseForm: {
        form: [
          {
            label: '登录账号',
            value: 'oldPhone',
            type: 'input',
            disabled: true,
            // default: this.userInfo.staffTFInfo.loginAcct,
          },
          {
            label: '验证码',
            value: 'verifyCodeOrigin',
            slot: true,
            hide: false,
          },
        ],
        rules: {
          oldPhone: [ // 登录账号
            { required: true, message: '登录账号', trigger: 'blur' },
          ],
          verifyCodeOrigin: [ // 验证码
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async getSms () { // 获取短信验证码
      if (this.smsTime > 0) {
        return;
      }
      this.smsTime = 20;
      const formData = await this.handleSubData(true);
      const res = await sendSmsCode({
        phone: formData.oldPhone,
        flag: 1,
      });
      if (!res.failed && res === 'Y') {
        this.$message.success('验证码已发送，请可留意查收');
        clearInterval(this.smsTimer);
        this.smsTimer = setInterval(() => {
          this.smsTime--;
          if (this.smsTime <= 0) {
            this.smsTime = 0;
            clearInterval(this.smsTimer);
          }
        }, 1000);
      } else if (!res.failed) {
        this.$message.error(res.errMesg);
        this.smsTime = 0;
      } else {
        this.smsTime = 0;
      }
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      // if (formData || cache) {
      //   formData = {
      //   };
      // }
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    init (data = {}) {
      data.oldPhone = data.oldPhone || this.userInfo.staffTFInfo.loginAcct;
      this.$refs.baseForm.setVal(data);
    },
  },
  mounted () {
    this.$refs.baseForm.setVal('oldPhone', this.userInfo.staffTFInfo.loginAcct);
  },
};
</script>

<style scoped lang="scss">
.getCodeBtn{
  padding-right: 8px;
}
.changeBtn{
  margin-left: 8px;
}
</style>
